import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, Images, MessageCircle, History } from "lucide-react";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels } from "@/i18n";

// export type TabType = "info" | "documents" | "images" | "messages" | "chat";
export type TabType = "info" | "documents" | "images" | "history";

interface CarCardTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const CarCardTabs = ({ activeTab, onTabChange }: CarCardTabsProps) => {
  const uiLabels = vehicleCardUILabels(getLanguage());
  
  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as TabType)}
      className="w-full pt-4"
    >
      <TabsList className="grid grid-cols-4 w-full bg-transparent border-b">
        <TabsTrigger
          value="info"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none"
        >
          <FileText className="h-4 w-4" />
          <span className="hidden sm:inline">{uiLabels.info}</span>
        </TabsTrigger>
        <TabsTrigger
          value="documents"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none"
        >
          <FileText className="h-4 w-4" />
          <span className="hidden sm:inline">{uiLabels.documents}</span>
        </TabsTrigger>
        <TabsTrigger
          value="images"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none"
        >
          <Images className="h-4 w-4" />
          <span className="hidden sm:inline">{uiLabels.images}</span>
        </TabsTrigger>
        <TabsTrigger
          value="history"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none"
        >
          <History className="h-4 w-4" />
          <span className="hidden sm:inline">{uiLabels.history}</span>
        </TabsTrigger>
        {/* <TabsTrigger value="chat" className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none rounded-none">
          <MessageCircle className="h-4 w-4" />
          <span className="hidden sm:inline">Chatt</span>
        </TabsTrigger> */}
      </TabsList>
    </Tabs>
  );
};
